import { cn } from 'src/utils/cn';
import {
  ENCOMPASS_FIELD_KIND,
  ENCOMPASS_FIELD_KIND_VALUES,
  type EncompassFieldKind,
} from 'src/services/encompass/getEncompassCustomFields';

export interface FieldKindToggleProps {
  readonly value: EncompassFieldKind;
  readonly onChange: (kind: EncompassFieldKind) => void;
  readonly ariaLabel?: string;
  readonly className?: string;
  readonly size?: 'sm' | 'md';
  readonly disabled?: boolean;
}

export function FieldKindToggle({
  value,
  onChange,
  ariaLabel = 'Field type',
  className,
  size = 'md',
  disabled = false,
}: FieldKindToggleProps) {
  const isSmall = size === 'sm';

  return (
    <div
      role="radiogroup"
      aria-label={ariaLabel}
      className={cn(
        'inline-flex items-center rounded-lg border border-gray-200 bg-gray-100 p-0.5 shadow-inner',
        className,
      )}
    >
      {ENCOMPASS_FIELD_KIND_VALUES.map((kind) => {
        const isSelected = value === kind;
        return (
          <button
            key={kind}
            type="button"
            role="radio"
            aria-checked={isSelected}
            disabled={disabled}
            onClick={() => {
              if (!disabled && value !== kind) {
                onChange(kind);
              }
            }}
            className={cn(
              'rounded-md font-semibold transition-all duration-150',
              isSmall ? 'px-2 py-0.5 text-[11px]' : 'px-2.5 py-1 text-xs',
              isSelected
                ? 'bg-white text-blue-600 shadow-xs'
                : 'text-gray-500 hover:text-gray-800 disabled:opacity-50',
            )}
          >
            {kind === ENCOMPASS_FIELD_KIND.STANDARD ? 'Standard' : 'Custom'}
          </button>
        );
      })}
    </div>
  );
}

export default FieldKindToggle;
